import React from 'react'

const DefaultPage = () => {
    return (
        <div className='flex flex-col items-center justify-center p-8'>
            <h5 className='px-1 mt-10 text-4xl font-semibold leading-4 text-slate-800 '>Uh-Oh...</h5>
            <h2 className='text-lg font-medium px-1 text-slate-400 mt-10 max-w-[800px] text-center leading-10'>Discover the Unexpected- The page you are looking for may have ventured elsewhere or been reimagined.</h2>
            <h1 className='sm:text-[220px] text-9xl text-red-300 mt-3 font-semibold'>404</h1>
        </div>
    )
}

export default DefaultPage;